export const useFilesClient = () => {
  const fileUploadUrl = "/api/files/";

  const uploadFiles = async (files: File[]) => {
    const formData = new FormData();
    files.forEach((file) => formData.append("files[]", file));
    return await $fetch<string[]>(fileUploadUrl, {
      body: formData,
      method: "POST",
    });
  };

  const uploadFile = async (file: File) => {
    const formData = new FormData();
    formData.append("files[]", file);
    try {
      return await $fetch<string[]>(fileUploadUrl, {
        body: formData,
        method: "POST",
      });
    } catch (e) {
      return undefined;
    }
  };

  const deleteFileByUrl = async (url: string) => {
    await $fetch(`${fileUploadUrl}${encodeURIComponent(url)}`, {
      method: "DELETE",
    });
  };

  return {
    uploadFile,
    fileUploadUrl,
    deleteFileByUrl,
    uploadFiles,
  };
};
